import FreeZonePlateShow from '@/common/components/base/plateShow/components/freeZonePlateShow/FreeZonePlateShow';
import MotorCyclePlateShow from '@/common/components/base/plateShow/components/motorCyclePlateShow/MotorCyclePlateShow';
import MotorFreeZonePlateShow from '@/common/components/base/plateShow/components/motorfreeZonePlateShow/MotorFreeZonePlateShow';
import VehiclePlateShow from '@/common/components/base/plateShow/components/vehiclePlateShow/VehiclePlateShow';
import { PlateShowType } from '@/common/components/base/plateShow/PlateShow.type';
import { VehiclePlateType } from '@/common/types/Files.type';
import {
  FreeZonePlateType,
  MotorCyclePlateType,
} from '@/common/types/Plate.type';
import { Box } from 'styled-system/jsx';

const PlateShow = ({
  plateData,
  className,
  vehicleType,
  vehicleDesign,
}: PlateShowType) => {
  const renderPlateType = () => {
    switch (vehicleDesign) {
      case 'free_zone':
        if (vehicleType === 'motorcycle') {
          return (
            <MotorFreeZonePlateShow
              plateData={plateData as FreeZonePlateType}
            />
          );
        } else {
          return (
            <FreeZonePlateShow plateData={plateData as FreeZonePlateType} />
          );
        }

      case 'country':
        if (vehicleType === 'car') {
          return <VehiclePlateShow plateData={plateData as VehiclePlateType} />;
        } else {
          return (
            <MotorCyclePlateShow plateData={plateData as MotorCyclePlateType} />
          );
        }
      default:
        return (
          <MotorCyclePlateShow plateData={plateData as MotorCyclePlateType} />
        );
    }
  };

  return <Box className={className}>{renderPlateType()}</Box>;
};

export default PlateShow;
